import React from "react";

/**
 * Floating compare bar — appears once 1+ product is queued for compare.
 * Extracted from InfoShopPage.jsx (v3.8.5). All data-testid contracts
 * (`compare-floating-bar`, `compare-bar-pill-*`, `compare-bar-clear`,
 * `compare-bar-open`) are preserved.
 */
export default function CompareFloatingBar({ t, comparePns, compareMax, onClearAll, onOpen }) {
  if (!comparePns.length) return null;

  return (
    <div
      data-testid="compare-floating-bar"
      className="fixed bottom-6 left-1/2 -translate-x-1/2 z-40 w-[min(720px,calc(100vw-2rem))] rounded-2xl border border-slate-200 bg-white/95 backdrop-blur-md shadow-2xl px-4 py-3 flex items-center gap-4"
    >
      <div className="flex-1 min-w-0">
        <div className="text-[10px] uppercase tracking-[0.22em] font-bold text-slate-500">
          {t("compare.bar_eyebrow")}
        </div>
        <div className="font-display font-semibold text-slate-900 text-sm mt-0.5">
          {comparePns.length} {t("compare.bar_selected")} · {t("compare.bar_max_of")} {compareMax}
        </div>
      </div>
      <div className="hidden sm:flex items-center -space-x-2">
        {comparePns.slice(0, 4).map((pn) => (
          <span
            key={pn}
            className="inline-flex items-center justify-center h-8 px-2 rounded-md bg-slate-100 border border-slate-200 font-mono text-[10px] font-bold text-slate-700"
            title={pn}
            data-testid={`compare-bar-pill-${pn}`}
          >
            {pn}
          </span>
        ))}
      </div>
      <button
        onClick={onClearAll}
        data-testid="compare-bar-clear"
        className="text-[11px] font-semibold text-slate-500 hover:text-rose-600 whitespace-nowrap"
      >
        {t("compare.clear_all")}
      </button>
      <button
        onClick={onOpen}
        disabled={comparePns.length < 2}
        data-testid="compare-bar-open"
        className="inline-flex items-center gap-1.5 bg-[#0072CE] hover:bg-[#005BA6] text-white text-sm font-semibold rounded-md px-4 py-2 disabled:opacity-40 disabled:cursor-not-allowed whitespace-nowrap"
      >
        {t("compare.bar_cta")}
      </button>
    </div>
  );
}
